<!-- src/app/pages/not-found/not-found.component.html -->
<section class="not-found-page">
  <div class="container">
    <div class="content">
      <div class="error-code">404</div>
      <h1>Page Not Found</h1>
      <p>
        This page doesn't exist - but Michigan's Libertarian Senate campaign does.
        Let's get you back on track.
      </p>
      <div class="actions">
        <a routerLink="/" class="btn-primary">Go Home</a>
        <a routerLink="/issues" class="btn-secondary">Our Platform</a>
        <a routerLink="/volunteer" class="btn-secondary">Get Involved</a>
      </div>
      <div class="quick-links">
        <a routerLink="/donate">Donate</a>
        <a routerLink="/events">Events</a>
        <a routerLink="/newsroom">Newsroom</a>
        <a routerLink="/contact">Contact</a>
      </div>
    </div>
  </div>
</section>
